import { AnimatePresence, motion } from 'framer-motion';
import { Backdrop } from '../../common';
import { useLayoutStore } from '../../layout';
import { useSearchStore } from '../stores';
import { SearchField } from './search-field/SearchField';
import { SearchPanel } from './search-panel/SearchPanel';
import { ErrorBoundary } from 'react-error-boundary';

export function Search() {
  const isDesktop = useLayoutStore.use.isDesktop();
  const isSearchOpen = useSearchStore.use.isSearchOpen();
  const setKeyword = useSearchStore.use.setKeyword();
  const setIsSearchOpen = useSearchStore.use.setIsSearchOpen();

  const close = () => {
    setIsSearchOpen(false);
    setKeyword('');
  };

  return (
    <>
      <Backdrop name="search" open={isSearchOpen} zIndex={1} onClick={close} />

      <AnimatePresence key="search">
        {isSearchOpen && (
          <motion.div
            className="tlw-z-1 tlw-fixed tlw-top-0 tlw-w-full tlw-bg-white tlw-rounded-b-xl tlw-overflow-hidden tlw-origin-top lg:tlw-right-0 lg:tlw-w-[41.2vw] lg:tlw-max-w-[627px] lg:tlw-rounded-none lg:tlw-bg-transparent"
            style={isDesktop ? { translateX: '-37%' } : { translateX: '0' }}
            initial={{ opacity: 0, scale: 0.85 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.85 }}
            transition={{
              opacity: { duration: 0.2, delay: 0.1 },
              scale: { duration: 0.3 },
            }}
          >
            <ErrorBoundary fallback={<div>SearchField</div>}>
              <SearchField />
            </ErrorBoundary>

            <ErrorBoundary fallback={<div>SearchPanel</div>}>
              <SearchPanel />
            </ErrorBoundary>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
